import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  getNotificationMessage,
  markersSelectors,
  setProfileItemId,
  showCurrentChatFriendMarkerCoordinate,
  singleMarkerUpdate,
  usersSelectors,
  setUserSectionPage,
  setIsBlogFormOpen,
  setOpenBlogForm,
  setChatSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setBlogRepostData,
  handleOpenModal
} from 'store'
import {
  MODAL_SECTION,
  REJECTED
} from 'utils/constants'

export const useGoToProfileMarker = () => {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()

  const {
    filters,
    userProfile
  } = useSelector(usersSelectors)
  const { markers } = useSelector(markersSelectors)

  const handleFiltersInfo = () => {
    let codewordFilterCount = 0
    let affinityFilterCount = 0
    let ownFilterCount = 0
    let filterAffinityList = []

    filters?.forEach((f) => {
      if (f?.type === 'affinities') {
        affinityFilterCount += 1
        filterAffinityList.push(f?.title)
      } else if (f?.type === 'code_word') {
        codewordFilterCount += 1
      } else {
        ownFilterCount += 1
      }
    })

    return {
      codewordFilterCount,
      affinityFilterCount,
      ownFilterCount,
      filterAffinityList
    }
  }

  const goToProfileMarker = async ({
    profileId,
    coordinates
  }) => {
    let result = []
    let isPassed = false

    if (
      markers.find((marker) => marker.id === profileId)
      || userProfile.find((profile) => profile.id === profileId)
    ) {
      isPassed = true
    } else {
      result = await dispatch(singleMarkerUpdate(profileId))
    }

    if (
      markers.find((marker) => marker.id === profileId)
      || userProfile.find((profile) => profile.id === profileId)
      || result?.payload?.length
    ) {
      const filtersInfo = handleFiltersInfo()
      let affinityMatchCount = 0

      if (
        !filtersInfo.ownFilterCount
        && !filtersInfo.codewordFilterCount
        && filtersInfo.affinityFilterCount
      ) {
        result?.payload[0]?.affinities.forEach((profileAffi) => {
          if (filtersInfo.filterAffinityList.includes(profileAffi)) {
            affinityMatchCount += 1
          }
        })
      }

      if (
        !filtersInfo.ownFilterCount
        && !filtersInfo.codewordFilterCount
        && filtersInfo.affinityFilterCount === affinityMatchCount
      ) {
        document.querySelector('#back-button')?.click()
        dispatch(setProfileItemId(''))

        sessionStorage.removeItem('openProfileAfterAnimation')
        sessionStorage.removeItem('openEventAfterAnimation')

        dispatch(setUserSectionPage('clear'))
        dispatch(setIsBlogFormOpen(false))
        dispatch(setOpenBlogForm(false))
        document.querySelector('#custom-popup-overlay')?.click()
        document.querySelector('#custom-popup-overlay-event')?.click()
        dispatch(setChatSectionPage('clear'))
        dispatch(setOpenPopupBlogs(false))
        dispatch(setOpenPopupEvents(false))
        dispatch(setNotificationSectionPage('clear'))
        dispatch(setBlogRepostData([]))
        // This is for map filter to move
        dispatch(handleOpenModal({ isOpen: false, section: MODAL_SECTION?.RightSection }))
        setSearchParams({})

        setTimeout(() => {
          dispatch(showCurrentChatFriendMarkerCoordinate({
            coord: coordinates,
            isStatic: true
          }))

          sessionStorage.setItem('openProfileAfterAnimation', profileId)
        }, 1050)
      } else {
        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'The marker filter hides this profile',
            isEditProfile: false
          })
        )
      }
    }
  }

  return goToProfileMarker
}
